import { SurveyQuestionFieldOption } from '../entities/survey_engine/SurveyQuestionFieldOption';

export function sortOptionsByWeight(
  options: SurveyQuestionFieldOption[],
): SurveyQuestionFieldOption[] {
  return [...options].sort((a, b) => a.weight - b.weight);
}
